import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import useWakeLock from './hooks/useWakeLock';

const root = ReactDOM.createRoot(document.getElementById('root'));

const onWebVitalsReport = (metric) => {
  console.log(metric);
};

function AppWrapper() {
  useWakeLock();
  
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

root.render(<AppWrapper />);

reportWebVitals(onWebVitalsReport);